<app-header mode="landing"></app-header>
<app-side-bar [mode]="sidebarMode"></app-side-bar>

<div class="landing-page-content">
  <div
    class="privacy-container w-full py-6 px-4 md:px-6 text-[#b6c2d6] selection:bg-[#f3a83b]/30 selection:text-[#e2e8f0]"
  >
    <div class="max-w-5xl mx-auto space-y-6">
      <div class="flex justify-between items-center pb-2"></div>

      <!-- Main Header Card -->
      <div
        class="bg-[#0d1117] border border-[#1a2332] p-6 md:p-8 rounded-2xl shadow-xl"
      >
        <span
          class="text-[10px] uppercase tracking-widest text-slate-400 font-bold block mb-1"
          style="font-family: &quot;Barlow Condensed&quot;, sans-serif"
        >
          Latest Version
        </span>
        <h2
          class="text-3xl md:text-4xl font-extrabold text-[#e2e8f0] uppercase tracking-wide mb-4"
          style="font-family: &quot;Barlow Condensed&quot;, sans-serif"
        >
          Privacy <span class="text-[#e7b53f]">Policy</span>
        </h2>

        <div
          class="text-[#b6c2d6] space-y-3 leading-relaxed text-[#b6c2d6]"
          style="
            font-size: 0.82rem;
            font-family: &quot;Plus Jakarta Sans&quot;, sans-serif;
          "
        >
          <p>
            Welcome to the Privacy Notice for <strong>Casinoze</strong>. This
            document explains how we collect, use, store, and share your
            personal information when you use our online gaming services.
            Protecting your privacy is our priority. By using our Services, you
            consent to this policy.
          </p>
        </div>
      </div>

      <!-- Summary of Key Points (KEY Badge) -->
      <div
        class="bg-[#0d1117] border border-[#1a2332] p-6 md:p-8 rounded-2xl shadow-xl"
      >
        <div class="flex items-center gap-3 mb-4">
          <span
            class="bg-[#f3a83b]/10 border border-[#f3a83b]/30 text-[#f3a83b] font-bold px-2 py-0.5 rounded tracking-wider uppercase"
            style="
              font-family: &quot;Plus Jakarta Sans&quot;, sans-serif;
              font-size: 0.6rem;
            "
          >
            KEY
          </span>
          <h2
            class="text-base md:text-lg font-bold text-[#e2e8f0] uppercase tracking-wide"
            style="font-family: &quot;Barlow Condensed&quot;, sans-serif"
          >
            Summary of Key Points
          </h2>
        </div>

        <div
          class="flex flex-col gap-2 text-[#b6c2d6]"
          style="
            font-size: 0.82rem;
            font-family: &quot;Plus Jakarta Sans&quot;, sans-serif;
          "
        >
          <div class="flex items-start gap-2.5">
            <span
              class="w-1.5 h-1.5 rounded-full bg-[#f3a83b] mt-1.5 shrink-0"
            ></span>
            <p class="leading-relaxed">
              <strong class="text-[#e2e8f0]"
                >Personal Information We Collect:</strong
              >
              We gather personal data based on your interactions with our
              Services, your choices, and the features you use.
            </p>
          </div>
          <div class="flex items-start gap-2.5">
            <span
              class="w-1.5 h-1.5 rounded-full bg-[#f3a83b] mt-1.5 shrink-0"
            ></span>
            <p class="leading-relaxed">
              <strong class="text-[#e2e8f0]">Sensitive Data:</strong> We do not
              process sensitive personal information such as racial or ethnic
              origin, religious beliefs, or sexual orientation.
            </p>
          </div>
          <div class="flex items-start gap-2.5">
            <span
              class="w-1.5 h-1.5 rounded-full bg-[#f3a83b] mt-1.5 shrink-0"
            ></span>
            <p class="leading-relaxed">
              <strong class="text-[#e2e8f0]"
                >Third-Party Data Collection:</strong
              >
              We may collect data from public sources, marketing partners, and
              social media platforms to improve your experience.
            </p>
          </div>
          <div class="flex items-start gap-2.5">
            <span
              class="w-1.5 h-1.5 rounded-full bg-[#f3a83b] mt-1.5 shrink-0"
            ></span>
            <p class="leading-relaxed">
              <strong class="text-[#e2e8f0]">Use of Your Information:</strong>
              Your data is processed to deliver, improve, and administer our
              Services, communicate with you, prevent fraud, and comply with
              laws.
            </p>
          </div>
          <div class="flex items-start gap-2.5">
            <span
              class="w-1.5 h-1.5 rounded-full bg-[#f3a83b] mt-1.5 shrink-0"
            ></span>
            <p class="leading-relaxed">
              <strong class="text-[#e2e8f0]">Data Sharing:</strong> We share
              your data only under specific circumstances with trusted partners,
              affiliates, or during business transitions.
            </p>
          </div>
          <div class="flex items-start gap-2.5">
            <span
              class="w-1.5 h-1.5 rounded-full bg-[#f3a83b] mt-1.5 shrink-0"
            ></span>
            <p class="leading-relaxed">
              <strong class="text-[#e2e8f0]">Your Rights:</strong> Depending on
              your jurisdiction, you have rights regarding your personal data,
              including access, correction, and deletion.
            </p>
          </div>
          <div class="flex items-start gap-2.5">
            <span
              class="w-1.5 h-1.5 rounded-full bg-[#f3a83b] mt-1.5 shrink-0"
            ></span>
            <p class="leading-relaxed">
              <strong class="text-[#e2e8f0]">Exercising Your Rights:</strong>
              Requests can be submitted to our privacy team, and we will act
              according to applicable data protection laws.
            </p>
          </div>
        </div>
      </div>

      <!-- Table of Contents -->
      <div
        class="bg-[#0d1117] border border-[#1a2332] p-6 md:p-8 rounded-2xl shadow-xl"
      >
        <span
          class="text-[.9rem] uppercase tracking-widest text-slate-400 font-bold block mb-4"
          style="font-family: &quot;Barlow Condensed&quot;, sans-serif"
        >
          Table of Contents
        </span>

        <ul
          class="space-y-3"
          style="
            font-size: 0.82rem;
            font-family: &quot;Plus Jakarta Sans&quot;, sans-serif;
          "
        >
          <li
            (click)="scrollToSection(1)"
            class="flex items-center gap-3 cursor-pointer group transition-colors duration-200 hover:text-[#e7b53f]"
          >
            <span
              class="text-[#f3a83b] font-bold w-5 transition-colors duration-200 group-hover:text-[#e7b53f]"
              >1</span
            >
            What Information Do We Collect?
          </li>
          <li
            (click)="scrollToSection(2)"
            class="flex items-center gap-3 cursor-pointer group transition-colors duration-200 hover:text-[#e7b53f]"
          >
            <span
              class="text-[#f3a83b] font-bold w-5 transition-colors duration-200 group-hover:text-[#e7b53f]"
              >2</span
            >
            How Do We Process Your Information?
          </li>
          <li
            (click)="scrollToSection(3)"
            class="flex items-center gap-3 cursor-pointer group transition-colors duration-200 hover:text-[#e7b53f]"
          >
            <span
              class="text-[#f3a83b] font-bold w-5 transition-colors duration-200 group-hover:text-[#e7b53f]"
              >3</span
            >
            When and With Whom Do We Share Your Personal Information?
          </li>
          <li
            (click)="scrollToSection(4)"
            class="flex items-center gap-3 cursor-pointer group transition-colors duration-200 hover:text-[#e7b53f]"
          >
            <span
              class="text-[#f3a83b] font-bold w-5 transition-colors duration-200 group-hover:text-[#e7b53f]"
              >4</span
            >
            Do We Use Cookies and Other Tracking Technologies?
          </li>
          <li
            (click)="scrollToSection(5)"
            class="flex items-center gap-3 cursor-pointer group transition-colors duration-200 hover:text-[#e7b53f]"
          >
            <span
              class="text-[#f3a83b] font-bold w-5 transition-colors duration-200 group-hover:text-[#e7b53f]"
              >5</span
            >
            How Do We Handle Your Social Logins?
          </li>
          <li
            (click)="scrollToSection(6)"
            class="flex items-center gap-3 cursor-pointer group transition-colors duration-200 hover:text-[#e7b53f]"
          >
            <span
              class="text-[#f3a83b] font-bold w-5 transition-colors duration-200 group-hover:text-[#e7b53f]"
              >6</span
            >
            Is Your Information Transferred Internationally?
          </li>
          <li
            (click)="scrollToSection(7)"
            class="flex items-center gap-3 cursor-pointer group transition-colors duration-200 hover:text-[#e7b53f]"
          >
            <span
              class="text-[#f3a83b] font-bold w-5 transition-colors duration-200 group-hover:text-[#e7b53f]"
              >7</span
            >
            How Long Do We Keep Your Information?
          </li>
          <li
            (click)="scrollToSection(8)"
            class="flex items-center gap-3 cursor-pointer group transition-colors duration-200 hover:text-[#e7b53f]"
          >
            <span
              class="text-[#f3a83b] font-bold w-5 transition-colors duration-200 group-hover:text-[#e7b53f]"
              >8</span
            >
            Do We Collect Information from Minors?
          </li>
          <li
            (click)="scrollToSection(9)"
            class="flex items-center gap-3 cursor-pointer group transition-colors duration-200 hover:text-[#e7b53f]"
          >
            <span
              class="text-[#f3a83b] font-bold w-5 transition-colors duration-200 group-hover:text-[#e7b53f]"
              >9</span
            >
            What Are Your Privacy Rights?
          </li>
          <li
            (click)="scrollToSection(10)"
            class="flex items-center gap-3 cursor-pointer group transition-colors duration-200 hover:text-[#e7b53f]"
          >
            <span
              class="text-[#f3a83b] font-bold w-5 transition-colors duration-200 group-hover:text-[#e7b53f]"
              >10</span
            >
            Controls for Do-Not-Track Features
          </li>
          <li
            (click)="scrollToSection(11)"
            class="flex items-center gap-3 cursor-pointer group transition-colors duration-200 hover:text-[#e7b53f]"
          >
            <span
              class="text-[#f3a83b] font-bold w-5 transition-colors duration-200 group-hover:text-[#e7b53f]"
              >11</span
            >
            Do We Make Updates to This Notice?
          </li>
          <li
            (click)="scrollToSection(12)"
            class="flex items-center gap-3 cursor-pointer group transition-colors duration-200 hover:text-[#e7b53f]"
          >
            <span
              class="text-[#f3a83b] font-bold w-5 transition-colors duration-200 group-hover:text-[#e7b53f]"
              >12</span
            >
            How Can You Contact Us About This Notice?
          </li>
          <li
            (click)="scrollToSection(13)"
            class="flex items-center gap-3 cursor-pointer group transition-colors duration-200 hover:text-[#e7b53f]"
          >
            <span
              class="text-[#f3a83b] font-bold w-5 transition-colors duration-200 group-hover:text-[#e7b53f]"
              >13</span
            >
            How Can You Review, Update, or Delete Your Data?
          </li>
        </ul>
      </div>

      <!-- Section 1 -->
      <div
        id="section-1"
        class="bg-[#0d1117] border border-[#1a2332] p-6 md:p-8 rounded-2xl shadow-xl scroll-mt-24"
      >
        <div class="flex items-center gap-3 mb-4">
          <span
            class="bg-[#f3a83b]/10 border border-[#f3a83b]/30 text-[#f3a83b] text-xs font-bold px-2 py-0.5 rounded"
            style="font-family: &quot;Plus Jakarta Sans&quot;, sans-serif"
            >1</span
          >
          <h2
            class="text-base md:text-lg font-bold text-[#e2e8f0] uppercase tracking-wide"
            style="font-family: &quot;Barlow Condensed&quot;, sans-serif"
          >
            What Information Do We Collect?
          </h2>
        </div>
        <div
          class="leading-relaxed text-[#b6c2d6] space-y-3"
          style="
            font-size: 0.82rem;
            font-family: &quot;Plus Jakarta Sans&quot;, sans-serif;
          "
        >
          <p>
            We collect personal data you voluntarily share when registering for
            our Services, contacting us, or participating in promotions. This
            may include your name, email address, payment information, and other
            account details. All data must be accurate and kept up to date.
          </p>
          <p>
            <strong class="text-[#e2e8f0]"
              >Information Automatically Collected:</strong
            >
            When you use our website and apps, we automatically gather technical
            information such as your IP address, device type, browser details,
            operating system, language preferences, referring URLs, and usage
            patterns.
          </p>
          <p>
            <strong class="text-[#e2e8f0]"
              >Cookies and Tracking Technologies:</strong
            >
            Casinoze uses cookies, web beacons, and similar technologies to
            collect information, save preferences, and deliver personalized
            content. You can manage cookie preferences through your browser
            settings.
          </p>
        </div>
      </div>

      <!-- Section 2 -->
      <div
        id="section-2"
        class="bg-[#0d1117] border border-[#1a2332] p-6 md:p-8 rounded-2xl shadow-xl scroll-mt-24"
      >
        <div class="flex items-center gap-3 mb-4">
          <span
            class="bg-[#f3a83b]/10 border border-[#f3a83b]/30 text-[#f3a83b] text-xs font-bold px-2 py-0.5 rounded"
            style="font-family: &quot;Plus Jakarta Sans&quot;, sans-serif"
            >2</span
          >
          <h2
            class="text-base md:text-lg font-bold text-[#e2e8f0] uppercase tracking-wide"
            style="font-family: &quot;Barlow Condensed&quot;, sans-serif"
          >
            How Do We Process Your Information?
          </h2>
        </div>
        <p
          class="leading-relaxed text-[#b6c2d6]"
          style="
            font-size: 0.82rem;
            font-family: &quot;Plus Jakarta Sans&quot;, sans-serif;
          "
        >
          We process your personal data to provide and improve the Casinoze
          platform; communicate with you regarding your account and promotions;
          secure the platform against fraud and unauthorized access; comply with
          legal and regulatory requirements; and conduct marketing with your
          consent where applicable. We only process data when we have a lawful
          basis.
        </p>
      </div>

      <!-- Section 3 -->
      <div
        id="section-3"
        class="bg-[#0d1117] border border-[#1a2332] p-6 md:p-8 rounded-2xl shadow-xl scroll-mt-24"
      >
        <div class="flex items-center gap-3 mb-4">
          <span
            class="bg-[#f3a83b]/10 border border-[#f3a83b]/30 text-[#f3a83b] text-xs font-bold px-2 py-0.5 rounded"
            style="font-family: &quot;Plus Jakarta Sans&quot;, sans-serif"
            >3</span
          >
          <h2
            class="text-base md:text-lg font-bold text-[#e2e8f0] uppercase tracking-wide"
            style="font-family: &quot;Barlow Condensed&quot;, sans-serif"
          >
            When and With Whom Do We Share Your Personal Information?
          </h2>
        </div>
        <p
          class="leading-relaxed text-[#b6c2d6]"
          style="
            font-size: 0.82rem;
            font-family: &quot;Plus Jakarta Sans&quot;, sans-serif;
          "
        >
          Your personal information may be shared in specific situations:
          <strong>Business Transfers</strong> — in the event of mergers or
          acquisitions; <strong>Affiliates</strong> — with subsidiaries bound by
          this Privacy Notice; <strong>Business Partners</strong> — trusted
          partners to provide services or promotions;
          <strong>Legal Obligations</strong> — to comply with legal processes or
          protect rights and safety.
        </p>
      </div>

      <!-- Section 4 -->
      <div
        id="section-4"
        class="bg-[#0d1117] border border-[#1a2332] p-6 md:p-8 rounded-2xl shadow-xl scroll-mt-24"
      >
        <div class="flex items-center gap-3 mb-4">
          <span
            class="bg-[#f3a83b]/10 border border-[#f3a83b]/30 text-[#f3a83b] text-xs font-bold px-2 py-0.5 rounded"
            style="font-family: &quot;Plus Jakarta Sans&quot;, sans-serif"
            >4</span
          >
          <h2
            class="text-base md:text-lg font-bold text-[#e2e8f0] uppercase tracking-wide"
            style="font-family: &quot;Barlow Condensed&quot;, sans-serif"
          >
            Do We Use Cookies and Other Tracking Technologies?
          </h2>
        </div>
        <p
          class="leading-relaxed text-[#b6c2d6]"
          style="
            font-size: 0.82rem;
            font-family: &quot;Plus Jakarta Sans&quot;, sans-serif;
          "
        >
          Yes. Cookies and tracking technologies help us enhance user
          experience, secure our Services, analyze trends, and display relevant
          content. These include session cookies, persistent cookies, web
          beacons, and pixels. You can control or disable cookies via your
          browser settings, but some features may be affected.
        </p>
      </div>

      <!-- Section 5 -->
      <div
        id="section-5"
        class="bg-[#0d1117] border border-[#1a2332] p-6 md:p-8 rounded-2xl shadow-xl scroll-mt-24"
      >
        <div class="flex items-center gap-3 mb-4">
          <span
            class="bg-[#f3a83b]/10 border border-[#f3a83b]/30 text-[#f3a83b] text-xs font-bold px-2 py-0.5 rounded"
            style="font-family: &quot;Plus Jakarta Sans&quot;, sans-serif"
            >5</span
          >
          <h2
            class="text-base md:text-lg font-bold text-[#e2e8f0] uppercase tracking-wide"
            style="font-family: &quot;Barlow Condensed&quot;, sans-serif"
          >
            How Do We Handle Your Social Logins?
          </h2>
        </div>
        <p
          class="leading-relaxed text-[#b6c2d6]"
          style="
            font-size: 0.82rem;
            font-family: &quot;Plus Jakarta Sans&quot;, sans-serif;
          "
        >
          If you register or log in through third-party social media accounts,
          we may receive profile data such as your name, email, friends list,
          and profile picture. We use this information solely for purposes
          outlined in this Notice. Please review the privacy policies of those
          platforms for their data handling practices.
        </p>
      </div>

      <!-- Section 6 -->
      <div
        id="section-6"
        class="bg-[#0d1117] border border-[#1a2332] p-6 md:p-8 rounded-2xl shadow-xl scroll-mt-24"
      >
        <div class="flex items-center gap-3 mb-4">
          <span
            class="bg-[#f3a83b]/10 border border-[#f3a83b]/30 text-[#f3a83b] text-xs font-bold px-2 py-0.5 rounded"
            style="font-family: &quot;Plus Jakarta Sans&quot;, sans-serif"
            >6</span
          >
          <h2
            class="text-base md:text-lg font-bold text-[#e2e8f0] uppercase tracking-wide"
            style="font-family: &quot;Barlow Condensed&quot;, sans-serif"
          >
            Is Your Information Transferred Internationally?
          </h2>
        </div>
        <p
          class="leading-relaxed text-[#b6c2d6]"
          style="
            font-size: 0.82rem;
            font-family: &quot;Plus Jakarta Sans&quot;, sans-serif;
          "
        >
          Your data may be transferred, stored, and processed outside your home
          country. We implement appropriate safeguards and comply with
          applicable laws to protect your personal information during such
          transfers.
        </p>
      </div>

      <!-- Section 7 -->
      <div
        id="section-7"
        class="bg-[#0d1117] border border-[#1a2332] p-6 md:p-8 rounded-2xl shadow-xl scroll-mt-24"
      >
        <div class="flex items-center gap-3 mb-4">
          <span
            class="bg-[#f3a83b]/10 border border-[#f3a83b]/30 text-[#f3a83b] text-xs font-bold px-2 py-0.5 rounded"
            style="font-family: &quot;Plus Jakarta Sans&quot;, sans-serif"
            >7</span
          >
          <h2
            class="text-base md:text-lg font-bold text-[#e2e8f0] uppercase tracking-wide"
            style="font-family: &quot;Barlow Condensed&quot;, sans-serif"
          >
            How Long Do We Keep Your Information?
          </h2>
        </div>
        <p
          class="leading-relaxed text-[#b6c2d6]"
          style="
            font-size: 0.82rem;
            font-family: &quot;Plus Jakarta Sans&quot;, sans-serif;
          "
        >
          We retain your personal information only as long as necessary to
          fulfill the purposes outlined in this Notice or as required by law.
          When data is no longer needed, we securely delete or anonymize it.
          Some information may be kept in backup archives for legal compliance.
        </p>
      </div>

      <!-- Section 8 -->
      <div
        id="section-8"
        class="bg-[#0d1117] border border-[#1a2332] p-6 md:p-8 rounded-2xl shadow-xl scroll-mt-24"
      >
        <div class="flex items-center gap-3 mb-4">
          <span
            class="bg-[#f3a83b]/10 border border-[#f3a83b]/30 text-[#f3a83b] text-xs font-bold px-2 py-0.5 rounded"
            style="font-family: &quot;Plus Jakarta Sans&quot;, sans-serif"
            >8</span
          >
          <h2
            class="text-base md:text-lg font-bold text-[#e2e8f0] uppercase tracking-wide"
            style="font-family: &quot;Barlow Condensed&quot;, sans-serif"
          >
            Do We Collect Information from Minors?
          </h2>
        </div>
        <p
          class="leading-relaxed text-[#b6c2d6]"
          style="
            font-size: 0.82rem;
            font-family: &quot;Plus Jakarta Sans&quot;, sans-serif;
          "
        >
          We do not knowingly collect personal information from children under
          18 years old. By using our Services, you confirm you are at least 18
          or have parental consent. If we discover we have collected data from a
          minor, we will promptly delete it.
        </p>
      </div>

      <!-- Section 9 -->
      <div
        id="section-9"
        class="bg-[#0d1117] border border-[#1a2332] p-6 md:p-8 rounded-2xl shadow-xl scroll-mt-24"
      >
        <div class="flex items-center gap-3 mb-4">
          <span
            class="bg-[#f3a83b]/10 border border-[#f3a83b]/30 text-[#f3a83b] text-xs font-bold px-2 py-0.5 rounded"
            style="font-family: &quot;Plus Jakarta Sans&quot;, sans-serif"
            >9</span
          >
          <h2
            class="text-base md:text-lg font-bold text-[#e2e8f0] uppercase tracking-wide"
            style="font-family: &quot;Barlow Condensed&quot;, sans-serif"
          >
            What Are Your Privacy Rights?
          </h2>
        </div>
        <p
          class="leading-relaxed text-[#b6c2d6]"
          style="
            font-size: 0.82rem;
            font-family: &quot;Plus Jakarta Sans&quot;, sans-serif;
          "
        >
          You may have rights under applicable laws to access, correct, or
          delete your personal data. You can also withdraw consent to data
          processing where applicable. For account changes or closure, contact
          our support team. Some data may be retained to comply with legal or
          fraud prevention requirements.
        </p>
      </div>

      <!-- Section 10 -->
      <div
        id="section-10"
        class="bg-[#0d1117] border border-[#1a2332] p-6 md:p-8 rounded-2xl shadow-xl scroll-mt-24"
      >
        <div class="flex items-center gap-3 mb-4">
          <span
            class="bg-[#f3a83b]/10 border border-[#f3a83b]/30 text-[#f3a83b] text-xs font-bold px-2 py-0.5 rounded"
            style="font-family: &quot;Plus Jakarta Sans&quot;, sans-serif"
            >10</span
          >
          <h2
            class="text-base md:text-lg font-bold text-[#e2e8f0] uppercase tracking-wide"
            style="font-family: &quot;Barlow Condensed&quot;, sans-serif"
          >
            Controls for Do-Not-Track Features
          </h2>
        </div>
        <p
          class="leading-relaxed text-[#b6c2d6]"
          style="
            font-size: 0.82rem;
            font-family: &quot;Plus Jakarta Sans&quot;, sans-serif;
          "
        >
          Currently, Casinoze does not respond to Do-Not-Track signals as there
          is no uniform industry standard. Should this change, we will update
          this Notice accordingly.
        </p>
      </div>

      <!-- Section 11 -->
      <div
        id="section-11"
        class="bg-[#0d1117] border border-[#1a2332] p-6 md:p-8 rounded-2xl shadow-xl scroll-mt-24"
      >
        <div class="flex items-center gap-3 mb-4">
          <span
            class="bg-[#f3a83b]/10 border border-[#f3a83b]/30 text-[#f3a83b] text-xs font-bold px-2 py-0.5 rounded"
            style="font-family: &quot;Plus Jakarta Sans&quot;, sans-serif"
            >11</span
          >
          <h2
            class="text-base md:text-lg font-bold text-[#e2e8f0] uppercase tracking-wide"
            style="font-family: &quot;Barlow Condensed&quot;, sans-serif"
          >
            Do We Make Updates to This Notice?
          </h2>
        </div>
        <p
          class="leading-relaxed text-[#b6c2d6]"
          style="
            font-size: 0.82rem;
            font-family: &quot;Plus Jakarta Sans&quot;, sans-serif;
          "
        >
          We periodically update this Privacy Notice to comply with legal
          requirements or improve transparency. Changes will be indicated by a
          revised date, and significant updates may be communicated via email or
          website notices. Please review this Notice regularly.
        </p>
      </div>

      <!-- Section 12 -->
      <div
        id="section-12"
        class="bg-[#0d1117] border border-[#1a2332] p-6 md:p-8 rounded-2xl shadow-xl scroll-mt-24"
      >
        <div class="flex items-center gap-3 mb-4">
          <span
            class="bg-[#f3a83b]/10 border border-[#f3a83b]/30 text-[#f3a83b] text-xs font-bold px-2 py-0.5 rounded"
            style="font-family: &quot;Plus Jakarta Sans&quot;, sans-serif"
            >12</span
          >
          <h2
            class="text-base md:text-lg font-bold text-[#e2e8f0] uppercase tracking-wide"
            style="font-family: &quot;Barlow Condensed&quot;, sans-serif"
          >
            How Can You Contact Us About This Notice?
          </h2>
        </div>
        <p
          class="leading-relaxed text-[#b6c2d6]"
          style="
            font-size: 0.82rem;
            font-family: &quot;Plus Jakarta Sans&quot;, sans-serif;
          "
        >
          For questions, concerns, or to exercise your privacy rights, please
          contact us through the support options available in your account
          dashboard.
        </p>
      </div>

      <!-- Section 13 / Footer Card -->

      <div
        id="section-13"
        class="bg-[#0d1117] border border-[#1a2332] p-6 md:p-8 rounded-2xl shadow-xl scroll-mt-24"
      >
        <div class="flex items-center gap-3 mb-4">
          <span
            class="bg-[#f3a83b]/10 border border-[#f3a83b]/30 text-[#f3a83b] text-xs font-bold px-2 py-0.5 rounded"
            style="font-family: &quot;Plus Jakarta Sans&quot;, sans-serif"
            >13</span
          >
          <h2
            class="text-base md:text-lg font-bold text-[#e2e8f0] uppercase tracking-wide"
            style="font-family: &quot;Barlow Condensed&quot;, sans-serif"
          >
            How Can You Review, Update, or Delete Your Data?
          </h2>
        </div>
        <p
          class="leading-relaxed text-[#b6c2d6]"
          style="
            font-size: 0.82rem;
            font-family: &quot;Plus Jakarta Sans&quot;, sans-serif;
          "
        >
          You may request access, correction, or deletion of your personal
          information by contacting our support team. We will respond in
          accordance with applicable laws. Thank you for trusting Casinoze. We
          are committed to protecting your privacy while delivering a secure and
          enjoyable gaming experience.
        </p>
      </div>
      <div
        class="bg-[#0d1117] border border-[#1a2332] p-6 md:p-8 rounded-2xl shadow-xl text-center space-y-4"
        style="font-family: &quot;Plus Jakarta Sans&quot;, sans-serif"
      >
        <p class="leading-relaxed text-[#e2e8f0]" style="font-size: 0.82rem">
          By continuing interaction routines with the Casinoze ecosystem, you
          affirm that you acknowledge the data tracking guidelines highlighted
          across this formal policy documentation.
        </p>

        <div
          class="text-[10px] md:text-xs uppercase tracking-widest text-[#e2e8f0] font-bold pt-2"
          style="font-family: &quot;Barlow Condensed&quot;, sans-serif"
        >
          © 2026 Casinoze — All Rights Reserved
        </div>
      </div>
    </div>
  </div>
  <app-footer mode="landing"></app-footer>
</div>
